export default function Footer() {
  return (
    <footer className="bg-[#1A1D2E] pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-8">
        {/* Top Section */}
        <div className="grid grid-cols-4 gap-12 mb-16">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/5d7361d22568520d4a403d18821c48f7.png" 
                alt="UnityCore" 
                className="h-10 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Профессиональный технический инжиниринг и сопровождение недвижимости в Турции для иностранных граждан
            </p>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-base font-semibold text-white mb-5" style={{ fontFamily: 'Montserrat, sans-serif' }}>Услуги</h4>
            <ul className="space-y-3">
              <li><a href="#services" className="text-sm text-gray-300 hover:text-[#D4745E] transition-colors cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>Проектирование</a></li>
              <li><a href="#services" className="text-sm text-gray-300 hover:text-[#D4745E] transition-colors cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>Строительство</a></li>
              <li><a href="#services" className="text-sm text-gray-300 hover:text-[#D4745E] transition-colors cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>Оценка недвижимости</a></li>
              <li><a href="#services" className="text-sm text-gray-300 hover:text-[#D4745E] transition-colors cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>Юридическое оформление</a></li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="text-base font-semibold text-white mb-5" style={{ fontFamily: 'Montserrat, sans-serif' }}>Компания</h4>
            <ul className="space-y-3">
              <li><a href="#team" className="text-sm text-gray-300 hover:text-[#D4745E] transition-colors cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>О нас</a></li>
              <li><a href="#portfolio" className="text-sm text-gray-300 hover:text-[#D4745E] transition-colors cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>Портфолио</a></li>
              <li><a href="#process" className="text-sm text-gray-300 hover:text-[#D4745E] transition-colors cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>Процесс работы</a></li>
              <li><a href="#contact" className="text-sm text-gray-300 hover:text-[#D4745E] transition-colors cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>Контакты</a></li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-base font-semibold text-white mb-5" style={{ fontFamily: 'Montserrat, sans-serif' }}>Контакты</h4>
            <ul className="space-y-3">
              <li className="text-sm text-gray-300" style={{ fontFamily: 'Montserrat, sans-serif' }}>+90 555 123 4567</li>
              <li className="text-sm text-gray-300" style={{ fontFamily: 'Montserrat, sans-serif' }}>info@unitycore.com</li>
              <li className="text-sm text-gray-300" style={{ fontFamily: 'Montserrat, sans-serif' }}>Стамбул, Турция</li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gray-700 mb-8"></div>

        {/* Bottom Section */}
        <div className="flex items-center justify-between">
          <p className="text-sm text-gray-500" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            © 2024 UnityCore. Все права защищены.
          </p>

          {/* Social Icons */}
          <div className="flex items-center gap-4">
            <a href="#" className="w-10 h-10 rounded-lg border border-white/20 flex items-center justify-center hover:border-[#D4745E] hover:bg-[#D4745E]/10 transition-all cursor-pointer">
              <i className="ri-linkedin-fill text-lg text-white"></i>
            </a>
            <a href="#" className="w-10 h-10 rounded-lg border border-white/20 flex items-center justify-center hover:border-[#D4745E] hover:bg-[#D4745E]/10 transition-all cursor-pointer">
              <i className="ri-facebook-fill text-lg text-white"></i>
            </a>
            <a href="#" className="w-10 h-10 rounded-lg border border-white/20 flex items-center justify-center hover:border-[#D4745E] hover:bg-[#D4745E]/10 transition-all cursor-pointer">
              <i className="ri-instagram-line text-lg text-white"></i>
            </a>
            <a href="#" className="w-10 h-10 rounded-lg border border-white/20 flex items-center justify-center hover:border-[#D4745E] hover:bg-[#D4745E]/10 transition-all cursor-pointer">
              <i className="ri-twitter-x-line text-lg text-white"></i>
            </a>
          </div>

          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-[#D4745E] transition-colors cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
